<template>
  <div id="pageDashboard" class="mainView">
    <v-container grid-list-xl fluid>
<!--      <v-layout row wrap>-->
<!--        &lt;!&ndash; mini statistic start &ndash;&gt;-->
<!--        <v-flex lg3 sm6 xs12>-->
<!--          <mini-statistic-->
<!--            icon="동승객 매칭중"-->
<!--            :title="mateAwaterCount"-->
<!--            sub-title="Passenger"-->
<!--            color="indigo"  -->
<!--          >-->
<!--          </mini-statistic>  -->
<!--        </v-flex>-->
<!--        <v-flex lg3 sm6 xs12>-->
<!--          <mini-statistic-->
<!--            icon="택시 매칭중"-->
<!--            :title="taxiAwaterCount"-->
<!--            sub-title="Passengers"-->
<!--            color="red"  -->
<!--          >-->
<!--          </mini-statistic>           -->
<!--        </v-flex>          -->
<!--        <v-flex lg3 sm6 xs12>-->
<!--          <mini-statistic-->
<!--            icon="탑승중"-->
<!--            :title="runningAwaitCount"-->
<!--            sub-title="Passengers"-->
<!--            color="light-blue"      -->
<!--          >-->
<!--          </mini-statistic>            -->
<!--        </v-flex>        -->
<!--        <v-flex lg3 sm6 xs12>-->
<!--          <mini-statistic-->
<!--            icon="운행 택시"-->
<!--            :title="runningTaxiCount"-->
<!--            sub-title="Drivers"-->
<!--            color="purple"      -->
<!--          >-->
<!--          </mini-statistic>             -->
<!--        </v-flex>   -->
<!--        &lt;!&ndash; mini statistic  end &ndash;&gt;   -->
<!--        <v-flex lg6 sm12 xs12>-->
<!--          <h3>동승객 매칭 대기자 목록</h3>-->
<!--          <v-divider></v-divider>-->
<!--          <v-card-text class="pa-0">-->
<!--            <template>-->
<!--              <v-data-table-->
<!--                :headers="complex.headers"-->
<!--                :items="complex.mateItems"-->
<!--                :rows-per-page-items="[5]"-->
<!--                class="elevation-0"-->
<!--                item-key="passengerId"-->
<!--                must-sort-->
<!--                :pagination.sync="pagination"-->
<!--                :custom-sort="customSort"-->
<!--                >-->
<!--                <template slot="items" slot-scope="props">-->
<!--                  <td class="text-sm-center" @click="openPessengerDetail(props.item.passengerId)"><a>{{ props.item.passengerId }}</a></td>-->
<!--                  <td class="text-sm-center" @click="openDialogMateAwait(props.item.passengerId)">{{ props.item.gender }}</td>-->
<!--                  <td class="text-sm-center" @click="openDialogMateAwait(props.item.passengerId)">{{ props.item.phoneNumber }}</td>     -->
<!--                  <td class="text-sm-center" @click="openDialogMateAwait(props.item.passengerId)">{{ props.item.startLocationName.split(' ')[props.item.startLocationName.split(' ').length - 2] + ' ' + props.item.startLocationName.split(' ')[props.item.startLocationName.split(' ').length - 1] }}</td>     -->
<!--                  <td class="text-sm-center" @click="openDialogMateAwait(props.item.passengerId)">{{ props.item.endLocationName.split(' ')[props.item.endLocationName.split(' ').length-2] + ' ' + props.item.endLocationName.split(' ')[props.item.endLocationName.split(' ').length-1] }}</td>-->
<!--                  <td class="text-sm-center" @click="openDialogMateAwait(props.item.passengerId)">{{ props.item.callOption }}</td>-->
<!--                  <td class="text-sm-center" @click="openDialogMateAwait(props.item.passengerId)">{{ Math.floor(( Date.now() - Date.parse(props.item.regDate) ) / 60000) + '분 ' + Math.floor(( Date.now() - Date.parse(props.item.regDate) ) % 60000 / 1000) + '초' }}</td>-->
<!--                  <td class="text-sm-center">-->
<!--                    <v-btn color="primary" small dark @click="openCallEventModal(props.item.passengerId, props.item.callOption)">등록</v-btn>-->
<!--                  </td>-->
<!--                </template>-->
<!--              </v-data-table>-->
<!--            </template>-->
<!--            <v-divider></v-divider>-->
<!--          </v-card-text>-->
<!--        </v-flex>-->
<!--        <v-flex lg6 sm12 xs12>-->
<!--          <h3>택시 매칭 대기자 목록</h3>-->
<!--          <v-divider></v-divider>-->
<!--          <v-card-text class="pa-0">-->
<!--            <template>-->
<!--              <v-data-table-->
<!--                :headers="complex.headers"-->
<!--                :items="complex.taxiItems"-->
<!--                :rows-per-page-items="[5]"-->
<!--                class="elevation-0"-->
<!--                item-key="passengerId"-->
<!--                must-sort-->
<!--                :pagination.sync="pagination2"-->
<!--                :custom-sort="customSort"-->
<!--                >-->
<!--                <template slot="items" slot-scope="props">-->
<!--                  <td class="text-sm-center" @click="openPessengerDetail(props.item.passengerId)"><a>{{ props.item.passengerId }}</a></td>-->
<!--                  <td class="text-sm-center" @click="openDialogMateAwait(props.item.passengerId)">{{ props.item.gender }}</td>-->
<!--                  <td class="text-sm-center" @click="openDialogTaxiAwait(props.item.passengerId)">{{ props.item.phoneNumber }}</td>    -->
<!--                  <td class="text-sm-center" @click="openDialogTaxiAwait(props.item.passengerId)">{{ props.item.startLocationName.split(' ')[props.item.startLocationName.split(' ').length - 2] + ' ' + props.item.startLocationName.split(' ')[props.item.startLocationName.split(' ').length - 1] }}</td>     -->
<!--                  <td class="text-sm-center" @click="openDialogTaxiAwait(props.item.passengerId)">{{ props.item.endLocationName.split(' ')[props.item.endLocationName.split(' ').length-2] + ' ' + props.item.endLocationName.split(' ')[props.item.endLocationName.split(' ').length-1] }}</td>-->
<!--                  <td class="text-sm-center" @click="openDialogTaxiAwait(props.item.passengerId)">{{ props.item.callOption }}</td>-->
<!--                  <td class="text-sm-center" @click="openDialogTaxiAwait(props.item.passengerId)">{{ Math.floor(( Date.now() - Date.parse(props.item.regDate) ) / 60000) + '분 ' + Math.floor(( Date.now() - Date.parse(props.item.regDate) ) % 60000 / 1000) + '초' }}</td>-->
<!--                </template>-->
<!--              </v-data-table>-->
<!--            </template>-->
<!--            <v-divider></v-divider>-->
<!--          </v-card-text>-->
<!--          <v-dialog v-model="awaitDetail.dialog" max-width="500px">-->
<!--            <v-card>-->
<!--              <v-card-title>-->
<!--                <span class="headline">대기자 상세조회</span>-->
<!--              </v-card-title>-->
<!--              <v-divider></v-divider>-->
<!--              <v-card-text>-->
<!--                <v-container grid-list-md>-->
<!--                  <v-layout wrap>-->
<!--                    <v-flex xs12>-->
<!--                      <v-text-field label="승객번호" :value="passengerId" disabled></v-text-field>-->
<!--                    </v-flex>-->
<!--                    <v-flex xs12>-->
<!--                      <v-text-field label="전화번호" :value="phoneNumber" disabled></v-text-field>-->
<!--                    </v-flex>-->
<!--                    <v-flex xs12>-->
<!--                      <v-text-field label="출발지" :value="startLocationName" disabled></v-text-field>-->
<!--                    </v-flex>-->
<!--                    <v-flex xs12>-->
<!--                      <v-text-field label="목적지" :value="endLocationName" disabled></v-text-field>-->
<!--                    </v-flex>-->
<!--                    <v-flex xs12>-->
<!--                      <v-text-field label="호출 시간" :value="regDate" disabled></v-text-field>-->
<!--                    </v-flex>-->
<!--                    <v-flex xs12>-->
<!--                      <v-text-field label="현재 상태" :value="status" disabled></v-text-field>-->
<!--                    </v-flex>-->
<!--                  </v-layout>-->
<!--                </v-container>-->
<!--              </v-card-text>-->
<!--              <v-card-actions>-->
<!--                <v-spacer>-->
<!--                </v-spacer>-->
<!--                <v-btn color="blue darken-1" flat @click="closeDialog">Close</v-btn>-->
<!--              </v-card-actions>-->
<!--            </v-card>-->
<!--          </v-dialog>-->
<!--        </v-flex>   -->
<!--        <v-flex lg12>-->
<!--          <h3>매칭된 승객 목록</h3>-->
<!--          <v-divider></v-divider>-->
<!--          <v-card-text class="pa-0">-->
<!--            <template>-->
<!--              <v-data-table-->
<!--                      :headers="complexMatch.headers"-->
<!--                      :items="complexMatch.items"-->
<!--                      class="elevation-0"-->
<!--                      item-key="passengerId"-->
<!--                      :hide-actions="true"-->
<!--              >-->
<!--                <template slot="items" slot-scope="props">-->
<!--                  <template v-if="props.item.driverId > 0">-->
<!--                    <td class="text-sm-center" @click="openDriverDetail(props.item.driverId)"><a>{{ props.item.driverId }}</a></td>-->
<!--                  </template>-->
<!--                  <template v-else>-->
<!--                    <td class="text-sm-center"></td>-->
<!--                  </template>-->
<!--                  <td class="text-sm-center">{{ props.item.callOption }}</td>-->
<!--                  <td class="text-sm-center" @click="openPessengerDetail(props.item.userId1)"><a>{{ props.item.userId1 }}</a></td>-->
<!--                  <td class="text-sm-center">{{ props.item.startLocationName1 }}</td>-->
<!--                  <td class="text-sm-center">{{ props.item.endLocationName1 }}</td>-->
<!--                  <td class="text-sm-center" @click="openPessengerDetail(props.item.userId2)"><a>{{ props.item.userId2 }}</a></td>-->
<!--                  <td class="text-sm-center">{{ props.item.startLocationName2 }}</td>-->
<!--                  <td class="text-sm-center">{{ props.item.endLocationName2 }}</td>-->
<!--                </template>-->
<!--              </v-data-table>-->

<!--            </template>-->
<!--            <v-divider></v-divider>-->
<!--          </v-card-text>-->
<!--        </v-flex>        -->
<!--      </v-layout>-->
    </v-container>

<!--    <ModalCallEventGenerator></ModalCallEventGenerator>-->
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
const _helpers = require('../../../node_modules/vuetify/es5/util/helpers');
const _slicedToArray = require('../../../mock/sliceToArray');
// import ModalCallEventGenerator from '../../components/modal/modal-call-event-generator';

export default {
  components: {
    VWidget,
    MiniStatistic
  },
  data () {
    return {
      autoReload: true,
      mateAwaterCount: '',
      taxiAwaterCount: '',
      runningAwaitCount: '',
      runningTaxiCount: '',
      pagination: {
        descending: true,
        sortBy: 'awaitTime'
      },
      pagination2: {
        descending: true,
        sortBy: 'awaitTime'
      },
      complex: {
        headers: [
          {
            text: '승객번호',
            value: 'passengerId',
            align: 'center'
          },
          {
            text: '성별',
            value: 'gender',
            align: 'center'
          },
          {
            text: '전화번호',
            value: 'phoneNumber',
            align: 'center'
          },
          {
            text: '출발지',
            value: 'startLocationName',
            align: 'center'
          },
          {
            text: '도착지',
            value: 'endLocationName',
            align: 'center'
          },
          {
            text: '콜 종류',
            value: 'callOption',
            align: 'center'
          },
          {
            text: '대기 시간',
            value: 'awaitTime',
            align: 'center'
          },
          {
            text: '',
            value: '',
            align: 'center'
          },
        ],
        mateItems: [],
        taxiItems: [],
      },
      complexMatch: {
        headers: [
          {
            text: '기사번호',
            value: 'driverId',
            align: 'center'
          },
          {
            text: '콜 종류',
            value: 'driverCallOption',
            align: 'center'
          },
          {
            text: '승객1-승객번호',
            value: 'userId1',
            align: 'center'
          },
          {
            text: '승객1-출발지',
            value: 'startLocationName1',
            align: 'center'
          },
          {
            text: '승객1-도착지',
            value: 'endLocationName1',
            align: 'center'
          },
          {
            text: '승객2-승객번호',
            value: 'userId2',
            align: 'center'
          },
          {
            text: '승객2-출발지',
            value: 'startLocationName2',
            align: 'center'
          },
          {
            text: '승객2-도착지',
            value: 'endLocationName2',
            align: 'center'
          }
        ],
        items: [],
      },
      awaitDetail: {
        dialog: false
      },
      passengerId: '123',
      phoneNumber: '010-1234-1234',
      startLocationName: '강남역 5번 출구_서울특별시 서초구 서초동',
      endLocationName: '판교역[신분당선]_경기 성남시 분당구 백현동',
      regDate: '2018.10.23 23:59',
      status: 'REGISTERED'
    };
  },
  mounted () {
    // 기사 관리자 권한 유저는 이 페이지를 볼 수 없습니다.
    if (localStorage.role == 'DRIVER_ADMIN') {
      this.$router.push('/screening');
    }

    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
    this.banbanCreated();
    if (this.$el.getElementsByClassName('v-icon indigo--text material-icons').length != 0) {
      this.$el.getElementsByClassName('v-icon indigo--text material-icons')[0].style = 'font-size: 20px; font-weight: bold';
      this.$el.getElementsByClassName('v-icon indigo--text material-icons')[0].classList.add('v-subheader');
    }
    if (this.$el.getElementsByClassName('v-icon red--text material-icons').length != 0) {
      this.$el.getElementsByClassName('v-icon red--text material-icons')[0].style = 'font-size: 20px; font-weight: bold';
      this.$el.getElementsByClassName('v-icon red--text material-icons')[0].classList.add('v-subheader');
    }
    if (this.$el.getElementsByClassName('v-icon light-blue--text material-icons').length != 0) {
      this.$el.getElementsByClassName('v-icon light-blue--text material-icons')[0].style = 'font-size: 20px; font-weight: bold';
      this.$el.getElementsByClassName('v-icon light-blue--text material-icons')[0].classList.add('v-subheader');
    }
    if (this.$el.getElementsByClassName('v-icon purple--text material-icons').length != 0) {
      this.$el.getElementsByClassName('v-icon purple--text material-icons')[0].style = 'font-size: 20px; font-weight: bold';
      this.$el.getElementsByClassName('v-icon purple--text material-icons')[0].classList.add('v-subheader');
    }
    this.awaitDetail.dialog = false;
  },
  methods: {
    banbanCreated () {
      // this.complex.mateItems = [];
      // this.complex.taxiItems = [];
      // const prameters = {
      //   method: 'realTimeCallStats'
      // };
      // this.$store.dispatch('banbanAPI', prameters)
      //   .then(({ data }) => {
      //     this.mateAwaterCount = String(data.mateAwaiterCount);
      //     this.taxiAwaterCount = String(data.taxiAwaiterCount);
      //     this.runningAwaitCount = String(data.runningAwaiterCount);
      //     this.runningTaxiCount = String(data.runningTaxiCount);
      //     this.complex.mateItems = data.mateAwaiters;
      //     // this.complex.mateItems = [{
      //     //   passengerId: 1,
      //     //   phoneNumber: '010-1234-1234',
      //     //   startLocationName: '강남역 5번 출구_서울특별시 서초구 서초동',
      //     //   endLocationName: '판교역[신분당선]_경기 성남시 분당구 백현동',
      //     //   awaitTime: '1',
      //     //   regDate: '2018.10.23 23:59',
      //     //   status: 'REGISTERED'
      //     // }];
      //     this.complex.taxiItems = data.taxiAwaiters;
      //     // this.complex.taxiItems = [{
      //     //   passengerId: 1,
      //     //   phoneNumber: '010-1234-1234',
      //     //   startLocationName: '강남역 5번 출구_서울특별시 서초구 서초동',
      //     //   endLocationName: '판교역[신분당선]_경기 성남시 분당구 백현동',
      //     //   awaitTime: '1',
      //     //   regDate: '2018.10.23 23:59',
      //     //   status: 'REGISTERED'
      //     // }];
      //     this.complexMatch.items = this.callbackMatch(data);
      //     // const tmpData = {"matchedAwaiters" : [{
      //     //     //승차1, 승차2, 하차1, 하차2 승객정보가 순서대로
      //     //     "getOnOffUserSeq": [
      //     //         {
      //     //             "userId": 1000, // 사용자 고유번호
      //     //             "startLat": 37.49848106397639, // 출발지 위도
      //     //             "startLon": 127.02701836824417, // 출발지 경도
      //     //             "startLocationName":"강남역 9번 출구",
      //     //             "endLat": 37.4156894667489, // 목적지 위도
      //     //             "endLon": 127.12543398141861, // 목적지 경도
      //     //             "endLocationName":"성남시 어딘가",
      //     //             "seat" : "FRONT" // 좌석(FRONT, REAR)
      //     //         },
      //     //         {
      //     //             "userId": 1002,
      //     //             "startLat": 37.49848106397639,
      //     //             "startLon": 127.02701836824417,
      //     //             "startLocationName":"강남역 9번 출구",
      //     //             "endLat": 37.405357943303436,
      //     //             "endLon": 127.11468368768692,
      //     //             "endLocationName":"성남시 어딘가",
      //     //             "seat" : "REAR"
      //     //         },
      //     //         {
      //     //             "userId": 1002,
      //     //             "startLat": 37.49848106397639,
      //     //             "startLon": 127.02701836824417,
      //     //             "startLocationName":"강남역 9번 출구",
      //     //             "endLat": 37.405357943303436,
      //     //             "endLon": 127.11468368768692,
      //     //             "endLocationName":"성남시 어딘가",
      //     //             "seat" : "FRONT"
      //     //         },
      //     //         {
      //     //             "userId": 1000,
      //     //             "startLat": 37.49848106397639,
      //     //             "startLon": 127.02701836824417,
      //     //             "startLocationName":"강남역 9번 출구",
      //     //             "endLat": 37.4156894667489,
      //     //             "endLon": 127.12543398141861,
      //     //             "endLocationName":"성남시 어딘가",
      //     //             "seat" : "REAR"
      //     //         }
      //     //     ],
      //     //     "predictTime": 2578, //예상 소요 시간(초)
      //     //     "totalDistance":21210, //총 운행거리(m)
      //     //     "driverId": 1028, //기사 고유번호(기사 매칭 후, 추가되는 정보)
      //     //     "taxiFee": {
      //     //         "totalFee": 18390, // 전체 택시 요금
      //     //         "taxiFee1": 8770, // 승객1의 택시 요금
      //     //         "taxiFee2": 9620// 승객2의 택시 요금
      //     //     }
      //     // }]}
      //     // this.complexMatch.items = this.callbackMatch(tmpData);
      //     top.getApp.progress.dialog = false;
      //   })
      //   .catch((error) => {
      //     if (top.getApp.commonError == null) {
      //       alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
      //     }
      //     top.getApp.commonError = null;
      //     top.getApp.progress.dialog = false;
      //   });
    },
    customSort (items, index, isDescending) {
      if (index === null) return items;
      return items.sort(function (a, b) {
        let sortA = '';
        let sortB = '';
        if (index === 'awaitTime') {
          sortA = Date.now() - Date.parse(a.regDate);
          sortB = Date.now() - Date.parse(b.regDate);
        }
        else {
          sortA = (0, _helpers.getObjectValueByPath)(a, index);
          sortB = (0, _helpers.getObjectValueByPath)(b, index);
        }
        if (isDescending) {
          let _ref = [sortB, sortA];
          sortA = _ref[0];
          sortB = _ref[1];
        }
        // Check if both are numbers
        if (!isNaN(sortA) && !isNaN(sortB)) {
          return sortA - sortB;
        }
        // Check if both cannot be evaluated
        if (sortA === null && sortB === null) {
          return 0;
        }

        let _map = [sortA, sortB].map(function (s) {
          return (s || '').toString().toLocaleLowerCase();
        });

        let _map2 = _slicedToArray.default.methods.slicedToArray(_map, 2);

        sortA = _map2[0];
        sortB = _map2[1];

        if (sortA > sortB) return 1;
        if (sortA < sortB) return -1;
        return 0;
      });
    },
    openDialogMateAwait (id) {
      for (let i = this.$parent.$parent.$el.getElementsByClassName('v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-disabled').length - 1; i >= 0; i--) {
        this.$parent.$parent.$el.getElementsByClassName('v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-disabled')[i].className = 'v-input v-text-field v-input--is-label-active v-input--is-dirty';
      }
      
      for (let j = 0; j < this.$parent.$children.length; j++) {
        if (this.$parent.$children[j].chkAutoReload != null) {
          clearInterval(this.$parent.$children[j].interval);
        }
      }
      for (let i = 0; i < this.complex.mateItems.length; i++) {
        if (this.complex.mateItems[i].passengerId === id) {
          this.passengerId = this.complex.mateItems[i].passengerId;
          this.phoneNumber = this.complex.mateItems[i].phoneNumber;
          this.startLocationName = this.complex.mateItems[i].startLocationName;
          this.endLocationName = this.complex.mateItems[i].endLocationName;
          this.regDate = this.complex.mateItems[i].regDate;
          this.status = this.complex.mateItems[i].status;
        }
      }
      this.awaitDetail.dialog = true;
    },
    openDialogTaxiAwait (id) {
      for (let i = this.$parent.$parent.$el.getElementsByClassName('v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-disabled').length - 1; i >= 0; i--) {
        this.$parent.$parent.$el.getElementsByClassName('v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-disabled')[i].className = 'v-input v-text-field v-input--is-label-active v-input--is-dirty';
      }
      
      for (let j = 0; j < this.$parent.$children.length; j++) {
        if (this.$parent.$children[j].chkAutoReload != null) {
          clearInterval(this.$parent.$children[j].interval);
        }
      }

      for (let i = 0; i < this.complex.taxiItems.length; i++) {
        if (this.complex.taxiItems[i].passengerId === id) {
          this.passengerId = this.complex.taxiItems[i].passengerId;
          this.phoneNumber = this.complex.taxiItems[i].phoneNumber;
          this.startLocationName = this.complex.taxiItems[i].startLocationName;
          this.endLocationName = this.complex.taxiItems[i].endLocationName;
          this.regDate = this.complex.taxiItems[i].regDate;
          this.status = this.complex.taxiItems[i].status;
        }
      }
      this.awaitDetail.dialog = true;
    },
    closeDialog () {
      for (let j = 0; j < this.$parent.$children.length; j++) {
        if (this.$parent.$children[j].chkAutoReload != null) {
          this.$parent.$children[j].chkAutoReload();
        }
      }
      this.awaitDetail.dialog = false;
    },
    callbackMatch (data) {
      let result = [];
      for (let i = 0; i < data.matchedAwaiters.length; i++) {
        const userId1 = data.matchedAwaiters[i].getOnOffUserSeq[0].userId;
        const startLocationName1 = data.matchedAwaiters[i].getOnOffUserSeq[0].startLocationName;
        const endLocationName1 = data.matchedAwaiters[i].getOnOffUserSeq[0].endLocationName;
        const userId2 = data.matchedAwaiters[i].getOnOffUserSeq[1].userId;
        const startLocationName2 = data.matchedAwaiters[i].getOnOffUserSeq[1].startLocationName;
        const endLocationName2 = data.matchedAwaiters[i].getOnOffUserSeq[1].endLocationName;
        const driverId = data.matchedAwaiters[i].driverId;
        const callOption = data.matchedAwaiters[i].getOnOffUserSeq[0].callOption;
        const tmpResult = {
          userId1: userId1,
          startLocationName1: startLocationName1,
          endLocationName1: endLocationName1,
          userId2: userId2,
          startLocationName2: startLocationName2,
          endLocationName2: endLocationName2,
          driverId: driverId,
          callOption: callOption
        };
        result.push(tmpResult);
      }

      return result;
    },
    openPessengerDetail (id) {
      this.$router.push('/member/passengerMemberDetail/' + id);
    },
    openDriverDetail (id) {
      this.$router.push('/member/driverMemberDetail/' + id);
    },
    openCallEventModal (id, callOption) {
      this.$modal.show('modal-call-event-generator', {userId: id, callOption: callOption});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/call/RealTimeCall.vue